module.exports = __webpack_public_path__ + "img/v5.4aed9648.png";